import React from "react";
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonItem,
  IonItemGroup,
  IonLabel,
  IonPage,
  IonRange,
  IonTitle,
  IonToolbar,
  isPlatform,
} from "@ionic/react";
import { FullScreenHandle } from "react-full-screen";
import { useTranslation } from "react-i18next";

const AVSettings: React.FC<{
  handle: FullScreenHandle;
  handleDismiss: () => void;
  isRunning: boolean;
  setIsRunning: (e: boolean) => void;
  sensitivityValue: number;
  handleSensitivity: (e: any) => void;
}> = ({
  handle,
  sensitivityValue,
  isRunning,
  setIsRunning,
  handleDismiss,
  handleSensitivity,
}) => {
  const { t } = useTranslation();
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="primary">
            <IonButton onClick={handleDismiss} className="!font-semibold">
              {t(`Done`)}
            </IonButton>
          </IonButtons>
          <IonTitle>{t(`Settings`)}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent color="light">
        <IonItemGroup className="item-group-input !bg-transparent margin">
          <IonItem className="item-input">
            <IonLabel className="min-w-[80px]">{t(`Sensitivity`)}</IonLabel>
            <IonRange
              value={sensitivityValue}
              min={0.7}
              max={2}
              step={0.1}
              defaultValue={1}
              onIonChange={handleSensitivity}
            />
          </IonItem>
          {
            // ios clients does not support fullscreen API...
            !isPlatform("iphone") && (
              <IonItem className="item-input" onClick={handle.enter}>
                <IonLabel color="primary">{t(`Enter fullscreen`)}</IonLabel>
              </IonItem>
            )
          }
        </IonItemGroup>

        <IonItemGroup className="item-group-input !bg-transparent margin">
          <IonButton
            className="item-button"
            expand="block"
            onClick={() => {
              setIsRunning(!isRunning);
              handleDismiss();
            }}
          >
            {isRunning ? t(`Pause`) : t(`Play`)}
          </IonButton>
        </IonItemGroup>
      </IonContent>
    </IonPage>
  );
};

export default AVSettings;
